import { renderToHTML } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ApplicationFormAnswers(props) {
  var _props$round;
  const roundQuestions = (_props$round = props.round) === null || _props$round === void 0 ? void 0 : _props$round.applicationQuestions;
  let answers = [];
  if (roundQuestions) {
    answers = roundQuestions.filter(q => !q.hidden && !q.encrypted).map(q => ({
      ...props.answers.find(a => a.questionId === q.id && a.question === q.title && a.type === q.type),
      question: q.title
    })).filter(a => !!a.answer);
  }
  if (answers.length === 0) {
    answers = props.answers.filter(a => !!a.answer && !a.hidden);
  }
  if (answers.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("h1", {
      className: "text-2xl mt-8 font-thin text-blue-800",
      children: "Additional Information"
    }), /*#__PURE__*/_jsx("div", {
      children: answers.map(answer => {
        const answerText = Array.isArray(answer.answer) ? answer.answer.join(", ") : answer.answer;
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-md mt-8 mb-3 font-semibold text-blue-800",
            children: answer.question
          }), answer.type === "paragraph" ? /*#__PURE__*/_jsx("p", {
            dangerouslySetInnerHTML: {
              __html: renderToHTML(answerText.replace(/\n/g, "\n\n"))
            },
            className: "text-md prose prose-h1:text-lg prose-h2:text-base prose-h3:text-base prose-a:text-blue-600"
          }) : /*#__PURE__*/_jsx("p", {
            className: "text-base text-blue-800",
            dangerouslySetInnerHTML: {
              __html: renderToHTML(answerText.replace(/\n/g, "\n\n"))
            }
          })]
        }, answer.questionId);
      })
    })]
  });
}